import React from 'react';

export const BillingPage: React.FC = () => {
  const currentDate = new Date();
  const renewalDate = new Date(currentDate);
  renewalDate.setDate(renewalDate.getDate() + 30);

  return (
    <div className="py-16 px-4">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-12">
          <h1 className="text-5xl font-bold text-white mb-6">
            Billing
          </h1>
          <p className="text-xl text-gray-300 mb-8">
            Manage Your Membership
          </p>
          
          <div className="bg-blue-500/10 border border-blue-500/20 rounded-lg p-6 max-w-3xl mx-auto">
            <p className="text-gray-300">
              You currently have a personal membership, but did you know your employer can pay for your membership directly? Check out our{' '}
              <a href="/teams" className="text-blue-400 hover:text-blue-300">Teams plan</a>
              {' '}and see if your employer is willing to invest in you skills!
            </p>
          </div>

          <div className="mt-6 text-gray-300">
            Membership will renew on {renewalDate.toLocaleDateString()}
          </div>

          <button className="mt-4 px-6 py-2 bg-gray-800 text-gray-300 rounded-lg hover:bg-gray-700 transition-colors">
            Manage Subscription
          </button>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Monthly Plan */}
          <div className="bg-gray-800/30 backdrop-blur border border-gray-700/50 rounded-lg p-8">
            <h3 className="text-lg font-semibold text-gray-300 mb-4">MONTHLY MEMBERSHIP</h3>
            <div className="mb-6">
              <span className="text-3xl font-bold text-white">$49 USD</span>
              <span className="text-gray-400 ml-2">(inc. taxes)</span>
            </div>
            <div className="text-2xl text-white mb-4">$32<span className="text-gray-400">/month</span></div>
            <div className="text-gray-400 mb-6">$384/year</div>
            <p className="text-gray-300 text-sm">
              You want to learn a specific skill, or complete a single course.
            </p>
          </div>

          {/* Annual Plan */}
          <div className="bg-gray-800/30 backdrop-blur border-2 border-yellow-500/50 rounded-lg p-8 relative">
            <div className="absolute -top-3 left-1/2 transform -translate-x-1/2 bg-yellow-500 text-black text-sm font-semibold px-4 py-1 rounded-full">
              Most Popular
            </div>
            <h3 className="text-lg font-semibold text-gray-300 mb-4">ANNUAL MEMBERSHIP</h3>
            <div className="mb-6">
              <span className="text-3xl font-bold text-white">$349 USD</span>
              <span className="text-gray-400 ml-2">(inc. taxes)</span>
            </div>
            <div className="text-2xl text-white mb-4">$229<span className="text-gray-400">/year</span></div>
            <div className="text-gray-400 mb-6">$247/month</div>
            <p className="text-gray-300 text-sm">
              You're committed to starting a tech-world career and getting hired.
            </p>
          </div>

          {/* Traditional University */}
          <div className="bg-gray-800/30 backdrop-blur border border-gray-700/50 rounded-lg p-8">
            <h3 className="text-lg font-semibold text-gray-300 mb-4">TRADITIONAL UNIVERSITY</h3>
            <div className="mb-6">
              <span className="text-3xl font-bold text-white">~$26,000</span>
              <span className="text-gray-400 ml-2">/year</span>
            </div>
            <div className="text-gray-400 mb-6">*source: educationdata.org</div>
            <p className="text-gray-300 text-sm">
              A 4-year degree is a good option for many students, but the cost in time and money can be significant. In many cases, it's particularly tough if you are going back to school after a career change.
            </p>
          </div>
        </div>

        <div className="mt-12 flex justify-center gap-4">
          <button className="px-6 py-3 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition-colors">
            Buy for a team
          </button>
          <button className="px-6 py-3 bg-gray-700 text-white rounded-lg hover:bg-gray-600 transition-colors">
            Get a membership
          </button>
        </div>
      </div>
    </div>
  );
}; 